import { defineStore } from 'pinia';

import { Member } from '@/Member/member.entity';

type MemberModalsState = {
    member: Member | null;
    members: Array<Member> | null;
    litigationName: string;
};

export const useMemberModalsStore = defineStore('memberModals', {
    state: (): MemberModalsState => ({
        member: null,
        members: null,
        litigationName: '',
    }),
    actions: {
        openMemberDetails(member: Member) {
            this.member = member;
        },
        closeMemberDetails() {
            this.member = null;
        },
        openLitigationMembers(members: Array<Member>, litigationName: string = '') {
            this.members = members;
            this.litigationName = litigationName;
        },
        closeLitigationMembers() {
            this.members = null;
            this.litigationName = '';
        },
    },
});
